module.exports = __webpack_public_path__ + "static/specSheet2-deaae623f454aa06985710356d1bdb16.svg";